export enum FornecedorScopesEnum {
  ComEndereco = 'ComEndereco',
}

export enum PessoaFornecedorEnum {
  FISICA = 'FISICA',
  JURIDICA = 'JURIDICA',
}
